import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import BrokerGrid from '@/pages/forex-trading/components/BrokerGrid';
import { brokerRecommendation } from '@/mocks/brokers';

export default function BrokerRecommendation() {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (!hash) return;
    const timer = window.setTimeout(() => {
      const target = document.getElementById(hash);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 150);
    return () => window.clearTimeout(timer);
  }, [location.hash]);

  return (
    <section id="brokers" className="scroll-mt-20 border-y border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow={brokerRecommendation.eyebrow}
            title={brokerRecommendation.title}
            subtitle={brokerRecommendation.subtitle}
          />
          <span className="inline-flex w-fit items-center gap-2 rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-[11px] font-medium text-foreground-600">
            <i className="ri-shield-check-line text-sm text-primary-600" />
            เนื้อหาเพื่อการศึกษา ไม่ใช่คำแนะนำการลงทุน
          </span>
        </div>

        <div className="mt-8 flex items-start gap-3 rounded-lg border border-background-300 bg-background-50 px-4 py-3">
          <i className="ri-draft-line mt-0.5 text-base text-accent-600" />
          <p className="text-xs leading-relaxed text-foreground-700">{brokerRecommendation.statusNote}</p>
        </div>

        <BrokerGrid />

        <div className="mt-6 grid grid-cols-1 gap-4 rounded-xl border border-background-300 border-l-2 border-l-accent-500 bg-background-50 p-5 md:grid-cols-2 md:gap-8 md:p-6">
          <div>
            <h3 className="flex items-center gap-2 font-heading text-sm font-semibold text-foreground-950">
              <i className="ri-links-line text-base text-primary-600" />
              {brokerRecommendation.disclosureTitle}
            </h3>
            <p className="mt-2 text-xs leading-relaxed text-foreground-600">{brokerRecommendation.disclosureText}</p>
          </div>
          <div className="border-t border-background-200 pt-4 md:border-l md:border-t-0 md:pl-8 md:pt-0">
            <h3 className="flex items-center gap-2 font-heading text-sm font-semibold text-foreground-950">
              <i className="ri-error-warning-line text-base text-accent-600" />
              {brokerRecommendation.riskTitle}
            </h3>
            <p className="mt-2 text-xs leading-relaxed text-foreground-600">{brokerRecommendation.riskText}</p>
          </div>
        </div>
      </div>
    </section>
  );
}